// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"010b5d2e","453":"b8146bf2"}[chunkId] + ".chunk.js";
};